import { render } from "./GoogleIcon.vue?vue&type=template&id=f1275690"
import script from "./GoogleIcon.vue?vue&type=script&lang=js"
export * from "./GoogleIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__